import dynamic from 'next/dynamic';
import { useEffectOnce } from 'react-use';
import { AccountSettingsTeamPermissionsSkeleton } from 'src/components/AccountSettingsTeamPermissions/AccountSettingsTeamPermissionsSkeleton';
import { AgentPageLayout } from 'src/components/AgentPageLayout';
import { useTeamId } from '@/utils/use-team-id';
import { useAgentAccountProfileUserQuery } from '@/views/agent-account-profile/agent-account-profile.generated';
import { AnalyticsEvent, useTrackEvent } from '$analytics';
import { useIdentity } from '$api-clients/hooks';

const AccountSettingsTeamPermissions = dynamic(
  () =>
    import(
      'src/components/AccountSettingsTeamPermissions/AccountSettingsTeamPermissions'
    ).then((exported) => exported.AccountSettingsTeamPermissions),
  { ssr: false, loading: () => <AccountSettingsTeamPermissionsSkeleton /> },
);

export default function AgentAccountProfilePage() {
  const { data, loading: isProfileLoading } = useAgentAccountProfileUserQuery({
    errorPolicy: 'all',
  });
  const userInfo = useIdentity('/auth/userinfo');

  const trackEvent = useTrackEvent();
  useEffectOnce(() => {
    trackEvent(AnalyticsEvent.AccountManagement, {
      eventContainer: 'team_management',
      eventTarget: 'team_management',
    });
  });

  const user = data?.me?.record;
  const teamId = useTeamId(userInfo.data, user?.agentTeam?.id);

  if (isProfileLoading) {
    return <AccountSettingsTeamPermissionsSkeleton />;
  }

  if (!user || !teamId) {
    throw new Error('Unable to load user');
  }

  return <AccountSettingsTeamPermissions userId={user.id} teamId={teamId} />;
}

AgentAccountProfilePage.Layout = AgentPageLayout;
